// fetchBaseQuery reports a 404 with no JSON body as PARSING_ERROR, with the code in originalStatus.
export const httpStatusOf = (error: unknown): number | undefined => {
  const candidate = error as { status?: number | string; originalStatus?: number } | null;
  if (typeof candidate?.status === "number") return candidate.status;
  return candidate?.originalStatus;
};

export const isNotFoundError = (error: unknown): boolean => httpStatusOf(error) === 404;
